import { RuleType, SupersededRule } from "@protos/issues/v1/issues";
import { SupersededRule as RegistrySupersededRule } from "@shared/types";

// Code isn't using protos so we have to do a bit of mapping
export function createSupersededRuleProto(
  rules: RegistrySupersededRule[]
): SupersededRule[] {
  return rules.map((r) => {
    let productEnum: RuleType;

    switch (r.product.toLowerCase()) {
      case "sast":
        productEnum = RuleType.SAST;
        break;
      case "secrets":
        productEnum = RuleType.SECRETS;
        break;
      default:
        productEnum = RuleType.UNSPECIFIED;
    }

    return {
      product: productEnum,
      rulePath: r.rule_path,
    };
  });
}

export const isSupersededBySecrets = (supersededBy: SupersededRule[]) => {
  return supersededBy.some((r) => r.product === RuleType.SECRETS);
};
